<template>
  <div class="list-detail project-detail">
    <div>
      <div class="g-ta-r g-mb-32">
        <template v-if="roleInfo.btnExec === 'show'">
          <Button
            type="primary"
            size="large"
            @click="changeState(6)"
            class="g-ml-16"
            >项目执行中</Button
          >
        </template>
        <template v-if="roleInfo.btnReview === 'show'">
          <Button
            type="primary"
            size="large"
            @click="changeState(7)"
            class="g-ml-16"
            >项目已完成</Button
          >
        </template>
        <template v-if="roleInfo.btnClose === 'show'">
          <Button
            type="primary"
            size="large"
            @click="changeState(8)"
            class="g-ml-16"
            >项目已关闭</Button
          >
        </template>
        <!-- <Button type="primary" size="large" @click="openFeed" class="g-ml-16">意见反馈</Button> -->
      </div>
      <Tabs v-model="currTab" :animated="false" @on-click="selectTabs">
        <TabPane label="项目基本情况" name="detail">
          <project-detail-display
            v-if="currTab == 'detail'"
            :info="info"
            :par="par"
            :parStruct="parStruct"
            :projectMember="projectMember"
            :pib="pib"
            :role="roleInfo"
            @on-audit="getDetail"
          ></project-detail-display>
        </TabPane>

        <TabPane label="项目财务管理" name="budgetMange">
          <div
            class="project-dashboard project-tab"
            v-if="currTab == 'budgetMange'"
          >
            <Tabs
              v-model="budgetMangeCurrTab"
              :animated="false"
              @on-click="selectTabs"
            >
              <!-- v-if="" -->
              <TabPane label="项目预算" name="budget" v-if="showBudget">
                <template v-if="budgetMangeCurrTab == 'budget'">
                  <project-budget
                    :project-id="selectedProject.id"
                    :project-info="projectInfo"
                    v-if="budgetMangeCurrTab == 'budget'"
                  ></project-budget>
                </template>
              </TabPane>
              <TabPane label="项目报价单" name="quotation">
                <div
                  class="big-content"
                  v-if="budgetMangeCurrTab == 'quotation'"
                >
                  <main-list :data="quotationList"></main-list>
                  <el-pagination
                    background
                    layout="prev, pager, next"
                    :page-size="1"
                    :total="quotationCount"
                    class="page_content"
                    @current-change="currentChange"
                    @prev-click="currentChange"
                    @next-click="currentChange"
                  >
                  </el-pagination>
                </div>
              </TabPane>
              <TabPane label="项目毛利润表" name="profit-statement">
                <profit-table
                  :project-info="projectInfo"
                  v-if="budgetMangeCurrTab == 'profit-statement'"
                  :show-title="false"
                ></profit-table>
              </TabPane>
            </Tabs>
          </div>
        </TabPane>
        <TabPane label="财务文件列表" name="tasks">
          <div class="project-dashboard project-tab">
            <Tabs
              v-model="tasksCurrTab"
              :animated="false"
              @on-click="selectTabs"
            >
              <!-- v-if="" -->
              <TabPane label="文件列表" name="filesList">
                <div class="filter">
                  <div>
                    <div class="label">筛选：</div>
                    <div class="value">
                      <div
                        class="item"
                        :class="{
                          'item--active': projectSearch === i.val,
                        }"
                        v-for="(i, k) in typeList"
                        :key="k"
                        @click="projectSearch = i.val 
                        changeFilterList('file')"
                      >
                        {{ i.label }}
                      </div>
                    </div>
                  </div>
                </div>
                <Table
                  class="files-table"
                  :columns="filesTabs.title"
                  :data="filesFilter"
                ></Table>
              </TabPane>
              
              <TabPane label="任务列表" name="tasksList">
                 <div class="filter">
                  <div>
                    <div class="label">筛选：</div>
                    <div class="value">
                      <div
                        class="item"
                        :class="{
                          'item--active': projectSearch === i.val,
                        }"
                        v-for="(i, k) in typeList"
                        :key="k"
                        @click="projectSearch = i.val 
                        changeFilterList('tasks')"
                      >
                        {{ i.label }}
                      </div>
                    </div>
                  </div>
                </div>
                <main-list-new :data="tasksFilter" ></main-list-new>
              </TabPane>
            </Tabs>
          </div>
        </TabPane>
        <TabPane label="人员安排及交付物" name="dashboard">
          <project-dashboard
            v-if="Object.keys(roleInfo).length && currTab === 'dashboard'"
            :projectMember="projectMember"
            :project-info="projectInfo"
            :roleInfo="roleInfo"
            :tab="currTab"
          ></project-dashboard>
        </TabPane>
        <TabPane label="客户满意度" name="questionnaire">
          <survey-list
            :customer-name="info.customerName"
            :project-name="info.name"
            v-if="currTab === 'questionnaire'"
            :is-loading="isSurveyLoading"
            :project-id="selectedProject.id"
            :can-add="surveyRole"
            :list="surveyList"
            @on-load="getASQList"
          ></survey-list>
        </TabPane>
      </Tabs>
    </div>

    <loading v-if="isLoading"></loading>
    <toast :is-toast="isToast" :msg="toastMsg" :status="toastState"></toast>
    <Modal
      v-model="feedModal"
      class-name="vertical-center-modal examine-modal"
      ok-text="提交意见"
      :closable="false"
      @on-ok="submitAdvice"
    >
      <div class="advice-repo">
        <Row>
          <i-col span="24">
            <div class="g-mb-16">
              <h4 class="">意见反馈</h4>
              <i-input
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 10 }"
                v-model="repo"
              ></i-input>
            </div>
            <!--<div class="form-btns">-->
            <!--<Button type="primary" class="submit-repo form-default-btn" size="large" @click="submitAdvice">提交意见</Button>-->
            <!--</div>-->
          </i-col>
        </Row>
      </div>
    </Modal>
  </div>
</template>

<script>
import Loading from "./popup/Loading";
import Toast from "./popup/Toast";
import { Project, Dashborad, BudgetAll } from "../API/api";
import ProjectDetailDisplay from "./ProjectDetailDisplay";
import MainList from "./MainList";
import MainListNew from "./MainListNew";
import SurveyList from "./SurveyList";
import ProjectDashboard from "./projects/dashboard/index.vue";
import ProjectBudget from "./projects/budget/index.vue";

import ProfitTable from "./finance/display/profitTable";
import AllQuotationList from "./projects/AllQuotationList/index.vue";
// 1待PAR审核，2PAR审核不通过 3 PAR审核通过 4待PIB审核，5PIB审核不通过 6审核通过执行中
export default {
  name: "project-detail",
  components: {
    SurveyList,
    MainList,
    ProjectDetailDisplay,
    Loading,
    Toast,
    ProjectDashboard,
    ProjectBudget,
    ProfitTable,
    AllQuotationList,
    MainListNew
  },
  props: {
    currentTable: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      typeList: [
        {
          label: "全部",
          val: 0,
        },
        {
          label: "应收",
          val: 1,
        },
        {
          label: "应付",
          val: 2,
        },
      ],
      projectSearch: 0,//文件列表绑定的应收应付
      tasksSearch:0,//任务列表绑定的应收应付
      curpage: 1,
      allTotal: 0,
      budgetMangeCurrTab: "budget",
      tasksCurrTab: "filesList",
      projectInfo: {},
      repo: "",
      isSurveyLoading: false,
      feedModal: false,
      currTab: "",
      isLoading: false,
      isToast: false,
      toastMsg: null,
      toastState: null,
      projectData: null,
      roleInfo: {},
      info: {},
      par: {},
      parStruct: [],
      projectMember: {},
      surveyRole: false,
      pib: "",
      tasks: [],
      tasksFilter:[],
      quotationList: [],
      quotationPage: 1,
      quotationCount: 0,
      files: [],
      filesFilter:[],
      surveyList: [],
      ASQConf: {
        projectId: null,
        page: 1,
        pageSize: 1000,
      },
      filesTabs: {
        label: "文件",
        data: [],
        title: [
          {
            title: "文件名称",
            key: "fileName",
            sortable: true,
            ellipsis: false,
            className: "bc-transparent",
          },
          {
            // width: 80,
            title: "文件地址",
            key: "fileAddress",
            sortable: false,
            className: "bc-transparent",
            render: (h, params) => {
              const row = params.row;
              const url = row.fileAddress;
              return h(
                "a",
                {
                  domProps: {
                    href: url,

                    target: "_blank",
                  },
                },
                url
              );
            },
          },
        ],
      },
      showBudget: true,
    };
  },
  computed: {
    isDetail() {
      return this.$store.state.projects.detail;
    },
    selectedProject() {
      return this.$store.state.projects.detail;
    },
  },
  watch: {
    isDetail: {
      handler(val) {
        if (val) {
          this.currTab = "detail";
          this.getDetail();
          this.getFile();
          this.getTasks();
          this.getQuotation();
          this.getSurveyRole();
          this.getParstruct();
          this.getProMember();
        } else {
          this.projectData = null;
        }
      },
      immediate: true,
    },
  },
  methods: {
    changeFilterList(){
      console.log(this.tasks,'this.tasks----')
        switch(this.projectSearch){
          case 0:
            this.filesFilter=this.files;
            this.tasksFilter=this.tasks;
            break;
            case 1:
               this.filesFilter=this.files.filter(item=>item.taskState=='应收')
               this.tasksFilter=this.tasks.filter(item=>item.taskState=='应收')
              break;
              case 2:
              this.filesFilter=this.files.filter(item=>item.taskState=='应付')
              this.tasksFilter=this.tasks.filter(item=>item.taskState=='应付')
              break;
              default:
            this.filesFilter=this.files;
            this.tasksFilter=this.tasks;
                break;
        }
      // }
    },
    currentChange(curpage) {
      this.quotationPage = curpage;
      this.quotationList = [];
      this.getQuotation();
    },
    getPermissionControlById() {
      let params = {
        projectId: this.selectedProject.id,
      };
      this.$http
        .post(BudgetAll.getwhiteList, this.qs.stringify(params))
        .then((res) => {
          const _data = res.data.retData;
          // const _dataId=_data.map(obj=> obj.uid)
          let uId = String(JSON.parse(localStorage.getItem("userInfo")).id);

          if (_data.indexOf(uId) != -1) {
            this.showBudget = true;
          } else {
            this.showBudget = false;
            this.budgetMangeCurrTab = "quotation";
          }
        });
    },
    getProMember() {
      this.$http
        .post(
          Dashborad.projectsku,
          this.qs.stringify({ projectId: this.selectedProject.id }),
          {
            headers: { Authorization: "Bearer " + this.$cookie.get("token") },
          }
        )
        .then((res) => {
          this.projectMember = res.data.retData;
        });
    },
    getParstruct() {
      this.$http
        .post(
          Project.parstruct,
          this.qs.stringify({ projectId: this.selectedProject.id }),
          { headers: { Authorization: "Bearer " + this.$cookie.get("token") } }
        )
        .then((res) => {
          this.parStruct = res.data.retData.data;
        });
    },
    getSurveyRole() {
      this.$http
        .post(
          Project.surveyRole,
          this.qs.stringify({ projectId: this.selectedProject.id }),
          { headers: { Authorization: "Bearer " + this.$cookie.get("token") } }
        )
        .then((res) => {
          let _data = res.data;
          if (_data.retCode === 0) {
            this.surveyRole = _data.retData.add;
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
    selectTabs(name) {
      console.log(name,'name-----')
      if(name=='tasksList'||name=='filesList'||name=='tasks'){
      this.projectSearch=0;
      this.filesFilter=this.files;
      this.tasksFilter=this.tasks;
      }
      if (name === "questionnaire") {
        this.getASQList();
      }
      //切换tab栏重置信息
      if (name == "quotation") {
        this.quotationPage = 1;
        this.quotationList = [];
        this.getQuotation();
      }
    },
    getASQList() {
      this.isSurveyLoading = true;
      this.ASQConf.projectId = this.info.id;
      this.$http
        .post(Project.surveyList, this.qs.stringify(this.ASQConf), {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") },
        })
        .then((res) => {
          const _data = res.data;
          if (_data.retCode === 0) {
            if (this.ASQConf.page === 1) {
              this.surveyList = _data.retData.paperList;
            } else {
              this.surveyList = this.surveyList.concat(_data.retData.paperList);
            }
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isSurveyLoading = false;
        });
    },
    changeState(state) {
      this.$http
        .post(
          Project.state,
          this.qs.stringify({ projectId: this.info.id, state }),
          { headers: { Authorization: "Bearer " + this.$cookie.get("token") } }
        )
        .then((res) => {
          const _data = res.data;
          this.isToast = true;
          this.toastMsg = _data.retMsg;
          if (_data.retCode === 0) {
            this.toastMsg = "项目状态已更改";
            this.getDetail();
          }
        })
        .catch((err) => {
          console.log("err", err);
        })
        .finally(() => {
          setTimeout(() => {
            this.isToast = false;
          }, 1500);
        });
    },
    openFeed() {
      this.feedModal = true;
    },
    submitAdvice() {
      this.$http
        .post(
          Project.adviceRepo,
          this.qs.stringify({ projectId: this.info.id, content: this.repo }),
          { headers: { Authorization: "Bearer " + this.$cookie.get("token") } }
        )
        .then((res) => {
          if (res.data.retCode === 0) {
            this.isToast = true;
            this.toastMsg = "提交成功";
            this.toastState = "success";
            setTimeout(() => {
              this.isToast = false;
              this.repo = "";
            }, 1500);
          }
        });
    },
    getQuotation() {
      let data = {
        page: this.quotationPage,
        page_size: 1,
        orderBy: "createTime",
        asc: "desc",
        projectId: this.selectedProject.id,
        toolkitId: 17,
      };
      this.$http
        .post(Project.tasklist, this.qs.stringify(data), {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") },
        })
        .then((res) => {
          let _data = res.data;
          if (_data.retCode === 0) {
            this.quotationList = _data.retData.data;
            //  quotationPage:1,
            this.quotationCount = Number(_data.retData.count);
          } else if (_data.retCode === 100014) {
            this.$cookie.delete("token");

            this.isToast = true;
            this.toastMsg = _data.retMsg;
          }
          setTimeout(() => {
            this.isToast = false;
            this.toastMsg = null;
            if (_data.retCode === 100014) {
              this.$cookie.delete("token");

              this.$router.push("/");
            }
          }, 1500);
        });
    },
    getTasks() {
      let data = {
        page: 1,
        page_size: 1000,
        orderBy: "createTime",
        asc: "desc",
        projectId: this.selectedProject.id,
      };
      this.$http
        .post(Project.tasklist, this.qs.stringify(data), {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") },
        })
        .then((res) => {
          let _data = res.data;
          if (_data.retCode === 0) {
            this.tasks = _data.retData.data;
            this.tasksFilter=this.tasks
            console.log(this.tasks,'this.tasks-------',this.tasksFilter)
          } else if (_data.retCode === 100014) {
            this.$cookie.delete("token");

            this.isToast = true;
            this.toastMsg = _data.retMsg;
          }
          setTimeout(() => {
            this.isToast = false;
            this.toastMsg = null;
            if (_data.retCode === 100014) {
              this.$cookie.delete("token");

              this.$router.push("/");
            }
          }, 1500);
        });
    },
    getFile() {
      let data = {
        page: 1,
        page_size: 1000,
        orderBy: "createTime",
        asc: "desc",
        projectId: this.selectedProject.id,
      };
      this.$http
        .post(Project.filelist, this.qs.stringify(data), {
          headers: { Authorization: "Bearer " + this.$cookie.get("token") },
        })
        .then((res) => {
          let _data = res.data;
          if (_data.retCode === 0) {
            this.files = _data.retData.data;
            this.filesFilter=this.files;
          } else if (_data.retCode === 100014) {
            this.$cookie.delete("token");

            this.isToast = true;
            this.toastMsg = _data.retMsg;
          }
          setTimeout(() => {
            this.isToast = false;
            this.toastMsg = null;
            if (_data.retCode === 100014) {
              this.$cookie.delete("token");

              this.$router.push("/");
            }
          }, 1500);
        });
    },
    getDetail() {
      this.isLoading = true;
      this.filesForm = [
        {
          fileName: "",
          url: "",
          contactsAccount: null,
          taxRate: null,
        },
      ];
      this.$http
        .post(
          Project.detail,
          this.qs.stringify({ projectId: this.selectedProject.id }),
          { headers: { Authorization: "Bearer " + this.$cookie.get("token") } }
        )
        .then((res) => {
          let _data = res.data;
          this.isLoading = false;

          if (_data.retCode === 0) {
            this.info = _data.retData.data.projectInfo;
            this.par = _data.retData.data.projectPar;
            this.roleInfo = _data.retData.data.roleInfo;

            this.pib = _data.retData.data.projectPib;
            this.projectInfo = {
              projectId: this.selectedProject.id,
              customerId: _data.retData.data.projectInfo.customerId,
            };
          } else if (_data.retCode === 100014) {
            this.$cookie.delete("token");

            this.isToast = true;
            this.toastMsg = _data.retMsg;
          }
          setTimeout(() => {
            this.isToast = false;
            this.toastMsg = null;
            if (_data.retCode === 100014) {
              this.$cookie.delete("token");

              this.$router.push("/");
            }
          }, 1500);
        });
    },
  },
  mounted() {
    console.log("------123----");
    let isAddBuget = this.$store.state.projects.isAddBuget;
    if (this.currentTable == 1 && !!isAddBuget) {
      this.currTab = "budgetMange";
      this.budgetMangeCurrTab = "budget";

      this.$forceUpdate();
    }
    this.getPermissionControlById();
  },
};
</script>

<style scoped lang="less">
.list-detail {
  position: relative;
  padding: 16px;
  background-color: #ced4da;
  > div:not(.nopass) {
    /*padding: 32px 32px 32px 64px;*/
    padding: 32px;
    background-color: #fff;
    margin-bottom: 16px;
  }
  /*.nopass {*/
  /*margin-bottom: 0!important;*/
  /*background-color: #ff8685;*/
  /*border-radius: 6px 6px 0 0;*/
  /*border: 0 none;*/
  /*height: 48px;*/
  /*line-height: 48px;*/
  /*padding: 0;*/
  /*font-size: 14px;*/
  /*color: #fff;*/
  /*overflow: hidden;*/
  /*!*display: flex;*!*/
  /*.alert-title {*/
  /*background-color: #fa5252;*/
  /*display: inline-block;*/
  /*vertical-align: top;*/
  /*height: 48px;*/
  /*line-height: 48px;*/
  /*text-align: center;*/
  /*width: 150px;*/
  /*margin-right: 24px;*/
  /*i {*/
  /*line-height: 1;*/
  /*}*/
  /*}*/
  /*.alert-detail {*/
  /*!*flex: 1;*!*/
  /*}*/
  /*}*/
}
.task-belong {
  a {
    text-decoration: underline;
  }
}
.project-dashboard {
  border: 1px solid #ced4da;
  visibility: visible !important;
  /deep/.ivu-tabs-nav-scroll {
    width: 60% !important;
  }
}
.page_content {
  margin: 20px 0;
  display: flex;
  justify-content: end;
}
   .filter {
      flex: none;
      overflow: hidden;
      background-color: #f8f9fa;
      margin-bottom:20px;
      padding-bottom: 10px;
      padding-left: 20px;
      > div {
        // margin-top: 10px;
        display: flex;
        .label {
          width: 72px;
          margin-top: 10px;
          flex: none;
          color: #868e96;
          line-height: 20px;
        }

        .value {
          flex: 1;
          display: flex;
          flex-wrap: wrap;
          word-break: unset;
          color: #343a40;
          .item {
            margin: 10px 20px 0 0;
            line-height: 20px;
            cursor: pointer;
            &:hover {
              color: #2d8ef8;
            }
            &--active {
              color: #2d8ef8;
            }
          }
        }
      }
    }
</style>
